export default __webpack_public_path__ + "static/media/ACV500x900.19f68ea0.jpg";